import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseConversation } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventConversationContactOptedIn = () => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handle = (data: IResponseConversation) => {
    conversationStore.updateItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationContactOptedIn, handle), [])
}
